export default __webpack_public_path__ + "static/media/login-cover.94f560ca.jpg";